/* eslint-disable no-useless-escape */
import React from 'react'
import PropTypes from 'prop-types'
import CodeMirror from 'react-codemirror'
import 'codemirror/mode/javascript/javascript'
import 'codemirror/addon/display/placeholder'
import 'codemirror/addon/display/autorefresh'
import 'codemirror/lib/codemirror.css'

const CustomDmTemplate = ({ input }) => (
  <div>
    <ul className='br-dm-attachments__requirements'>
      <li>Enter custom Facebook Send DM payload below</li>
      <li>Use JSON syntax</li>
      <li>DO NOT INCLUDE RECIPIENT ID</li>
    </ul>

    <CodeMirror
      options={{
        lineNumbers: true,
        autoRefresh: true,
        lineWrapping: true
      }}
      value={input.value}
      mode='javascript'
      onChange={input.onChange}
    />
    <div className='br-input-footer'>
      <a
        href='https://developers.facebook.com/docs/messenger-platform/reference/send-api/'
        target='_blank'
        rel='noopener noreferrer'
      >
        <span
          className='fa fa-question-circle'
          title='Facebook Send DM API reference '
        />
      </a>
    </div>
  </div>
)

CustomDmTemplate.propTypes = {
  input: PropTypes.any
}

export default CustomDmTemplate



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-triggers-actions/actions/facebook/send-facebook-blast/custom-template.js